export default __webpack_public_path__ + "147b1e1ff73d455941ceb54e9b7f88da.svg";